export default "__VITE_ASSET__BByj_N2g__"